import React, { useRef, useState } from 'react';
import { MapToastsContainer, PlacesNearbyButton } from '../mapToastsStyles';
import SingleToast from '../SingleToast/SingleToast';
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces';
import ClusterToasts from '../ClusterToasts/ClusterToasts';
import { IonIcon, IonModal } from '@ionic/react';
import { list } from 'ionicons/icons';
import { Place } from '../../../../../models/Place';

type MapToastsProps = {
	showToasts: boolean;
	clusterToasts: boolean;
	places: Place[];
};

const MapToasts: React.FC<MapToastsProps> = ({
	showToasts,
	clusterToasts,
	places,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const placesNearby = useRef(null);
	const onWillDismiss = (ev: CustomEvent<OverlayEventDetail>) => {
		if (ev.detail.role === 'confirm') {
		}
	};
	return (
		<>
			{showToasts && (
				<MapToastsContainer>
					<PlacesNearbyButton>
						<IonIcon icon={list} onClick={() => setIsOpen(true)} />
					</PlacesNearbyButton>

					{clusterToasts ? (
						<ClusterToasts places={places} />
					) : (
						<SingleToast place={places[0]} margin={'0.5rem'} />
					)}
				</MapToastsContainer>
			)}
			<IonModal
				isOpen={isOpen}
				ref={placesNearby}
				onWillDismiss={(ev: CustomEvent<OverlayEventDetail>) =>
					onWillDismiss(ev)
				}
				initialBreakpoint={0.85}
				breakpoints={[0, 0.85]}
				keepContentsMounted={true}
				onDidDismiss={() => setIsOpen(false)}>
				List nearby Places!!
			</IonModal>
		</>
	);
};

export default MapToasts;
